export const CHAT_MESSAGE_PHOTO_LOAD_STATUS = 'CHAT_MESSAGE_PHOTO_LOAD_STATUS'

interface ChatMessagePhotoLoadedAction {
  type: typeof CHAT_MESSAGE_PHOTO_LOAD_STATUS
  messageId: number
  loaded: boolean
}

export const chatMessagePhotoLoadedAction = (
  messageId: number,
  loaded: boolean
) => ({
  type: CHAT_MESSAGE_PHOTO_LOAD_STATUS,
  messageId,
  loaded,
})

export const CHAT_MESSAGE_RESET_PHOTO_LOAD_STATUS =
  'CHAT_MESSAGE_RESET_PHOTO_LOAD_STATUS'

interface ChatMessengerResetPhotoLoadedAction {
  type: typeof CHAT_MESSAGE_RESET_PHOTO_LOAD_STATUS
}

export type ChatMessengerPhotoTypes =
  | ChatMessagePhotoLoadedAction
  | ChatMessengerResetPhotoLoadedAction
